import { render, staticRenderFns } from "./GlcAcknowledgementStatus.vue?vue&type=template&id=3b777f48&scoped=true"
import script from "./GlcAcknowledgementStatus.vue?vue&type=script&lang=js"
export * from "./GlcAcknowledgementStatus.vue?vue&type=script&lang=js"
import style0 from "./GlcAcknowledgementStatus.vue?vue&type=style&index=0&id=3b777f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b777f48",
  null
  
)

export default component.exports